// extracted by mini-css-extract-plugin
module.exports = {"section":"_2fgM8G1h-xCWbRu2csxsjP","signup":"_2kS8KOGlqn_oMbq_k1hvZT","login":"_2szWPw9eGIKxyLI8bfIK_F"};